import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchVideos } from "./../../features/videos/videosSlice";
import VideoGridItem from "./VideoGridItem";

const VideoGrid = () => {
  const dispatch = useDispatch();
  const videostate = useSelector((state) => state.videos);
  const { tags, search, author, page, limit } = useSelector((state) => state.filter);

  const { videos, isLoading, isError, error } = videostate;
  useEffect(() => {
    dispatch(fetchVideos({ tags, search, author, page, limit }));
  }, [tags, search, author, page, limit, dispatch]);
  return (
    <section className='pt-12'>
      <div className='grid grid-cols-12 gap-4 max-w-7xl mx-auto px-5 lg:px-0 min-h-[300px]'>
        {isLoading && <div className='col-span-12'>Loading...</div>}
        {!isLoading &&
          !isError &&
          videos?.length > 0 &&
          videos.map((video) => <VideoGridItem video={video} key={video.id} />)}
        {!isLoading && !isError && videos?.length === 0 && <h1>No Video Found !</h1>}

        {isError && <div className='col-span-12'>{error}</div>}
      </div>
    </section>
  );
};

export default VideoGrid;
